export enum PriceBreakdownLineItemType {
  APPLICABLE_COSTS = 'applicable_costs',
  CREDIT = 'goat_credit',
  INCLUDED_TAX_AND_DUTY = 'included_tax_and_duty',
  PRIORITY_PROCESSING = 'priority_processing',
  PRODUCT_PRICE = 'product_price',
  PROMOTION = 'promotion',
  SHIPPING = 'shipping',
  SUBTOTAL = 'subtotal',
  SUBTOTAL_TOTAL_PRICE = 'subtotal_total_price',
  TAX = 'tax',
}
